import {
  makeListState,
  makePaginationState,
  makeOffsetPaginationState,
  STATUSES,
  concatUnique,
} from 'app/utils/redux';

import * as t from './types';

const initialState = {
  banners: makeListState(),
  stories: makePaginationState(),
  sectionContents: makeOffsetPaginationState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_INITIAL_SECTION}_PENDING`:
      return {
        ...state,
        sectionContents: {
          ...state.sectionContents,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_INITIAL_SECTION}_SUCCESS`:
      return {
        ...state,
        sectionContents: {
          sectionId: action.meta.sectionId,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: action.payload.result.contents,
          },
        },
      };
    case `${t.FETCH_INITIAL_SECTION}_ERROR`:
      return {
        ...state,
        sectionContents: {
          ...state.sectionContents,
          status: STATUSES.ERROR,
          isLoaded: false,
        },
      };

    case `${t.FETCH_SECTION_CONTENTS}_SUCCESS`:
      return {
        ...state,
        sectionContents: {
          sectionId: action.meta.sectionId,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...state.sectionContents.pagination,
            lastEvaluatedKey: action.payload.result.lastEvaluatedKey,
            items: concatUnique(
              state.sectionContents.pagination.items,
              action.payload.result.items
            ),
          },
        },
      };

    // fetch section banners
    case `${t.FETCH_SECTION_BANNERS}_PENDING`:
      return {
        ...state,
        banners: {
          ...state.banners,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_SECTION_BANNERS}_SUCCESS`:
      return {
        ...state,
        banners: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result,
        },
      };
    case `${t.FETCH_SECTION_BANNERS}_ERROR`:
      return {
        ...state,
        banners: {
          ...state.banners,
          status: STATUSES.ERROR,
        },
      };

    case t.SET_SECTION_CONTENTS:
      return {
        ...state,
        sectionContents: {
          ...state.sectionContents,
          pagination: {
            ...state.sectionContents.pagination,
            uuid: action.meta.contents.uuid,
            lastEvaluatedKey: action.meta.contents.lastEvaluatedKey,
            items: action.meta.contents.contents,
          },
        },
      };

    case `${t.FETCH_CURATION}_SUCCESS`: {
      const stories = action.payload.result.sections.find(
        (s) => s.contentType === 'STY'
      );
      const banners = action.payload.result.sections.find(
        (s) => s.contentType === 'BNR'
      );

      return {
        ...state,
        sectionContents: {
          sectionId: action.meta.sectionId,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...stories,
            name: action.payload.result.name,
            items: stories.contents,
          },
        },
        ...(banners
          ? {
              banners: {
                ...state.banners,
                status: STATUSES.SUCCESS,
                isLoaded: true,
                list: banners.contents,
              },
            }
          : {}),
      };
    }

    // reset
    case t.RESET:
      return {
        ...state,
        banners: makeListState(),
        sectionContents: makeOffsetPaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/curationList/reducer.js